






















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { UserPaginator, UsersState } from '@/stores/users/types';
import Paginator from '@/components/Paginator.vue';
import { PaginatorEvent } from '@/types';
import CreateUserModal from '@/components/modals/CreateUserModal.vue';

const namespace: string = 'users';

@Component({
    components: {
        Paginator,
        CreateUserModal,
    },
})
export default class Claims extends Vue {
    @State('users') users!: UsersState;
    @Action('get', { namespace }) getUsers: any;
    @Action('create', { namespace }) createUser: any;
    @Action('setStatus', { namespace }) setUserStatus: any;
    @Getter('users', { namespace }) usersPaginator!: UserPaginator;

    currentPage: any = 1;
    perPage: any = 10;
    search: string = '';
    archived: boolean = false;

    fields: any = [
        {
            key: 'name',
            label: 'Name',
        },
        {
            key: 'email',
            label: 'Username',
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    @Watch('search')
    @Watch('archived')
    onPropertyChanged() {
        this.updateUsers();
    }

    mounted() {
        this.currentPage = this.$route.query.page || 1;
        this.perPage = this.$route.query.per_page || 10;
        this.updateUsers();
    }

    updateUsers() {
        this.getUsers({
            page: this.currentPage,
            perPage: this.perPage,
            search: this.search,
            archived: this.archived,
            hide: true,
        });
    }

    updatePaginate(paginatorObject: PaginatorEvent) {
        this.perPage = paginatorObject.perPage;
        this.currentPage = paginatorObject.currentPage;
        this.updateUsers();
    }

    get usersData() {
        return this.usersPaginator.data;
    }

    get usersPages() {
        return this.usersPaginator.metadata;
    }

    saveUser(user: any) {
        this.createUser({
            user,
        });
    }

    openNewUserModal() {
        this.$nextTick(() => {
            ((this.$refs.createUserModalRef) as any).showModal();
        });
    }

    activate(index: number, active: boolean) {
        this.setUserStatus({
            user: this.usersData[index],
            active,
            admin: this.usersData[index].admin,
            hide: this.usersData[index].hide,
        });
    }

    admin(index: number, admin: boolean) {
        this.setUserStatus({
            user: this.usersData[index],
            admin,
            active: this.usersData[index].active,
            hide: this.usersData[index].hide,
        });
    }

    hide(index: number, hide: boolean) {
        this.setUserStatus({
            user: this.usersData[index],
            hide,
            active: this.usersData[index].active,
            admin: this.usersData[index].admin,
        });
    }
}
